var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"isPc",attrs:{"id":"app"}},[(_vm.header_show)?_c('Header'):_vm._e(),_c('router-view',{staticClass:"main_warp",on:{"public_header":_vm.public_header,"public_footer":_vm.public_footer}}),(_vm.footer_show)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }